import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router";
import toastr from "../components/elements/toast";
import httpApiCall from "../service/api.service";
import { getStorageValue } from "../service/shared.service";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { saveWebsiteData } from "../Redux/Slices/MainSlice";
import Spinner from "react-bootstrap/Spinner";
import { global, whiteArrow } from "../assets/assets";
import { getDomainSuggestions } from "../service/common_function";

const toastrService = new toastr(true);

const WebsiteLiveModal = (props: any = []) => {
  const [allDomains, setAllDomains] = useState<any>([]);
  const [sppiner, setSppiner] = useState(false);
  const [domainCreate, setDomainCreate] = useState(false);
  const [inputTrue, setInputTrue] = useState(false);
  const [allotment, setAllotment] = useState("");
  const [allotmentNot, setAllotmentNot] = useState("");
  const [dataValue, setDataValue] = useState("");
  const dispatch = useDispatch();

  const [selectedDomian, setSelectedDomian] = useState({
    domainName: "",
    domainData:''
  });
  // console.log(props);

  useEffect(() => {
    setAllotment("");
    setting();
  }, []);
  const setting = async () => {
    if (props && props.alldomains) {
      setAllDomains(props.alldomains);
    } else {
      const getDomainData = await getDomainSuggestions();
      if (getDomainData) {
        setAllDomains(getDomainData);
      }
    }
  };

  const handleSubmit = async (formData: any) => {
    setSppiner(true);
    let profileData = getStorageValue("partnerProfile");
    profileData = profileData && profileData[0];
    if (
      formData &&
      !formData.domainName &&
      (!formData.domainData || !formData.domainData.trim())
    ) {
      toastrService.showError("Please select domain name");
      setSppiner(false);
      return;
    }

    if (domainCreate && (formData && formData.domainData) && (!allotment || !inputTrue) ) {
      let domainCheck = await checkDomainAvaliable({
        domain: formData.domainData,
      });
      if (domainCheck && domainCheck.is_error == 0) {
        // props.onHide();
        setSppiner(false);
        setAllotment("Domain is Available");
        setInputTrue(true);
      }else {
        setAllotmentNot("Domain Not Available")
        setSppiner(false);
        return
      }
      setSppiner(false);
    }
    if (!domainCreate || (allotment && inputTrue)) {
      let domainUrl = await requestDomainAllotment({
        domain:
          formData && formData.domainName
            ? formData.domainName
            : formData.domainData,
        partner_id: profileData.partner_id,
        props: props,
      });

      if (domainUrl && !domainUrl.is_error && domainUrl.message) {
        setSppiner(false);
        props.onHide();
        dispatch(
          saveWebsiteData({
            WebsiteModalShow: false,
            AddWebsiteModel: false,
            DomainAllotmentModal: true,
          })
        );
      } else {
        setSppiner(false);
      }
    }
    // setSelectedDomian(formData.domainName);
  };
const handleClose = () => {
  setDomainCreate(false);
  props.onHide()
}
  const validationSchema = Yup.object({
    domainData: Yup.string().when([], (i, schema) => {
      return domainCreate
        ? schema.required("Please select domain name").matches(/^[a-zA-Z0-9_]+$/ ,'Special character not required')
        : schema.notRequired();
    }),
  });

  
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="websiteLiveModal"
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h1> Select Custom Domain Name</h1>
            <p>Pick from below or create your own</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              onSubmit={handleSubmit}
              initialValues={selectedDomian}
              validationSchema={validationSchema}
            >

              {({setFieldValue}) =>(
                <Form>
                <div>
                  {allDomains &&
                    allDomains.map((domain: any, i: any) => (
                      <div key={i} className="mb-3">
                        <div className="domain_make">
                          <label className="label_input">
                            <div>
                              <Field
                                className="-form-control domain_checkbox"
                                type="radio"
                                name="domainName"
                                value={domain}
                                onClick={() => setDomainCreate(false)}
                              />
                              <label className="mb-1"></label>
                            </div>
                            {domain}
                          </label>
                        </div>
                      </div>
                    ))}
                  <div className="mb-3">
                    <div className="domain_make">
                      <label className="label_input">
                        <div>
                          <Field
                            className="-form-control domain_checkbox"
                            type="radio"
                            name="domainName"
                            checked={domainCreate}
                            onClick={() => setDomainCreate(true)}
                          />
                          <label className="mb-1"></label>
                        </div>
                        Create your own domain
                      </label>
                    </div>
                    {domainCreate && (
                      <div className="custom_domain">
                        <label className="createDomain">
                          <Field
                            type="text"
                            name="domainData"
                            placeholder="Search for available domain name"
                            className={`domain ${allotment && inputTrue ? "alotgreen" : allotmentNot ? "borderRed" : ""}`}
                            onClick={() => setInputTrue(false)}
                          />
                          <span className="suffic">.credee.net</span>
                        </label>
                        {inputTrue && (allotment || allotmentNot) && <p className={allotment ? "allot" : "red"}>{allotment ? allotment : allotmentNot}</p>}
                        <small className="text-danger m-2">
                          <ErrorMessage name="domainData" />
                        </small>
                      </div>
                    )}
                  </div>
                  <small className="text-danger">
                    <ErrorMessage name="domain" />
                  </small>
                </div>
                <div className="col-12 button_chase">
                  <button disabled={sppiner} className="loginBtn" type="submit">
                    {(!domainCreate || (domainCreate && allotment != "")) && (
                      <img src={global} alt="" />
                    )}
                    {(domainCreate && (!allotment || !inputTrue))
                      ? "Search Domain"
                      : "Make It Live"}
                    <img src={whiteArrow} alt="" />
                    {sppiner && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </button>
                </div>
              </Form>
              )}
              
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WebsiteLiveModal;

const requestDomainAllotment = async ({ domain, partner_id, props }: any) => {
  const token = getStorageValue("partnerToken");
  const body = {
    domainName: domain.trim(),
    partner_id: partner_id,
    domain_type: props.domain_type,
    template_id: props.template_id,
    access_token: token,
  };
  const domainUrl = await httpApiCall({
    api: "requestDomainAllotment",
    type: "post",
    body,
  });

  if (domainUrl && domainUrl.is_error) {
    toastrService.showError(domainUrl?.original_text || domainUrl.err);
  }
  return domainUrl;
};
const checkDomainAvaliable = async ({ domain }: any) => {
  const token = getStorageValue("partnerToken");
  const body = {
    access_token: token,
    domain: domain.trim(),
  };
  const createDomain = await httpApiCall({
    api: "checkDomainAvaliable",
    type: "post",
    body,
  });
  if (createDomain && createDomain.is_error) {
    toastrService.showError(createDomain?.original_text || createDomain.err);
  }
  return createDomain;
};
